/* eslint-disable consistent-return */
import { DependencyList, useEffect, useState } from 'react';

export function useUpdateEffect(effect: () => void, deps: DependencyList) {
  const [isMounted, setIsMounted] = useState(false);

  useEffect(() => {
    if (isMounted) {
      return effect();
    }
    setIsMounted(true);
  }, deps);
}
